import { useQuery } from "@tanstack/react-query";
import { getFinancialControlSummary } from "./api";

// currentPeriod returns the current YYYY-MM (used as the default).
export function currentPeriod() {
  const d = new Date();
  const m = String(d.getMonth() + 1).padStart(2, "0");
  return `${d.getFullYear()}-${m}`;
}

// useFinancialControlSummary loads the control summary for the given period
// (defaults to the current month).
export function useFinancialControlSummary(period) {
  const p = period || currentPeriod();
  return useQuery({
    queryKey: ["financial-control-summary", p],
    queryFn: () => getFinancialControlSummary({ period: p }),
    staleTime: 5 * 60 * 1000,
    refetchOnWindowFocus: false,
    // Revalidate whenever the dashboard is (re)opened so a just-saved budget is
    // reflected without a manual reload; budget save/activate also invalidates this key.
    refetchOnMount: "always",
  });
}
